import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { useIntersectionObserver } from './useIntersectionObserver';

interface ExternalProps {
  hideSticky?: boolean;
}
interface IProps {
  children: React.ReactNode;
}

export function Item2StickySidebar({ children, hideSticky = false }: ExternalProps & IProps) {
  const [canStick, setCanStick] = useState(false);
  const elementRef = useRef<HTMLDivElement>();
  const clientHeight = elementRef.current?.clientHeight;
  const windowHeight = useWindowHeight();
  const { setTrackedRef, entry } = useIntersectionObserver({});

  useEffect(() => {
    setCanStick(clientHeight < windowHeight);
  }, [clientHeight, windowHeight]);

  if (!children) return null;

  const entryIsVisible = entry?.isIntersecting;

  const classes = classNames(
    'item2-sticky-sidebar',
    { 'item2-sticky-sidebar--sticky': canStick && !hideSticky },
    { 'item2-sticky-sidebar--stuck': canStick && !entryIsVisible && !hideSticky },
  );

  return (
    <div className={classes}>
      <div className="item2-sticky-sidebar__observer" ref={setTrackedRef} />
      <div className="item2-sticky-sidebar__content" ref={elementRef}>
        {children}
      </div>
    </div>
  );
}

function useWindowHeight() {
  const [windowHeight, setWindowHeight] = useState(undefined);

  useEffect(() => {
    function handleResize() {
      setWindowHeight(window?.innerHeight);
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowHeight;
}
